
import IconButton from '@/ui-kit/components/icon-button';
import { ShapeType } from '@/ui-kit/components/icon-button/enums';
import { StyleSizeType, StyleColorSchemeType } from '@/ui-kit/styles/enums';
import { IconType } from '@/ui-kit/components/icon/enums';
import ModalService from '@/ui-kit/components/modal/ModalService';
import WindowSize from '@/ui-kit/mixins/windowSize';
import ListingImage from '@/components/images/listing';
import ImageGallery from '@/components/image-gallery';
import { ImageGalleryPaginationType, ImageGallerySlotName } from '@/components/image-gallery/enums';
import { ListingPageEvent } from '@/constants/AnalyticEvents';
import {
  SeePhotosAction,
  SeeVideoAction,
  Take3DTourAction,
} from './helpers/actions';
import { ListingGallerySlotName } from './enums';
import ListingGalleryImagesModal from './images-modal';
import GalleryImagesMixin from './mixins/GalleryImagesMixin';
import ListingActionsMixin from './mixins/ListingActionsMixin';

const PREVIEW_IMAGES_COUNT = 4;

export default {
  name: 'ListingGallery',
  components: {
    ListingImage,
    IconButton,
    ImageGallery,
  },
  mixins: [GalleryImagesMixin, ListingActionsMixin, WindowSize],
  props: {
    listing: {
      required: true,
      type: Object,
    },
    editable: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      StyleSizeType,
      StyleColorSchemeType,
      ListingGallerySlotName,
      IconType,
      ShapeType,
      imageGalleryActiveIndex: 0,
      ImageGallerySlotName,
      ImageGalleryPaginationType,
    };
  },
  computed: {
    highresImages() {
      return this.listing.images.map(({ highResUrl }) => highResUrl);
    },
    previewImagesCount() {
      const hasAdditionalImage = this.getHasSlot(ListingGallerySlotName.AdditionalPhoto);

      return PREVIEW_IMAGES_COUNT - Number(hasAdditionalImage);
    },
    previewImages() {
      const previewImageStartIndex = 1;
      const previewImageEndIndex = previewImageStartIndex + this.previewImagesCount;

      return this.highresImages.slice(previewImageStartIndex, previewImageEndIndex);
    },
    galleryTitledActions() {
      return [this.seePhotoAction, this.seeVideoAction, this.see3DTourAction]
        .filter((value) => value);
    },
    seePhotoAction() {
      const areAllImagesShown = this.previewImages.length + 1 >= this.highresImages.length;
      const analyticEvent = this.getTrackEventWithOrigin(ListingPageEvent.PhotosViewed);

      return !areAllImagesShown && new SeePhotosAction({
        analyticEvent,
        modalData: { store: this.$store },
      });
    },
    seeVideoAction() {
      const analyticEvent = this.getTrackEventWithOrigin(ListingPageEvent.VideoViewed);

      return this.listing.videoTour && new SeeVideoAction({ analyticEvent });
    },
    see3DTourAction() {
      const analyticEvent = this.getTrackEventWithOrigin(ListingPageEvent.ThreeDTourViewed);

      return this.listing.virtualTour && new Take3DTourAction({ analyticEvent });
    },
    actionSize() {
      if (this.isSmallerThan(StyleSizeType.Small)) {
        return StyleSizeType.XSmall;
      }

      return StyleSizeType.Small;
    },
  },
  methods: {
    getHasSlot(slotType) {
      return !!this.$slots[slotType];
    },
    handleImageClick(index) {
      return ModalService.open({
        component: ListingGalleryImagesModal,
        data: {
          listing: this.listing,
          store: this.$store,
          activeIndex: index,
        },
      });
    },
    handleActiveIndexChange(index) {
      this.imageGalleryActiveIndex = index;
    },
  },
};
